/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { PtwValidationResult } from './PtwValidationResult';
import {
    PtwValidationResultFromJSON,
    PtwValidationResultFromJSONTyped,
    PtwValidationResultToJSON,
} from './PtwValidationResult';
import type { ExceptionData } from './ExceptionData';
import {
    ExceptionDataFromJSON,
    ExceptionDataFromJSONTyped,
    ExceptionDataToJSON,
} from './ExceptionData';
import type { I18nInfo } from './I18nInfo';
import {
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';
import type { Exception } from './Exception';
import {
    ExceptionFromJSON,
    ExceptionFromJSONTyped,
    ExceptionToJSON,
} from './Exception';

/**
 * 
 * @export
 * @interface Ptw100BadRequestException
 */
export interface Ptw100BadRequestException {
    /**
     * 
     * @type {string}
     * @memberof Ptw100BadRequestException
     */
    readonly targetSite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100BadRequestException
     */
    readonly message?: string | null;
    /**
     * 
     * @type {ExceptionData}
     * @memberof Ptw100BadRequestException
     */
    data?: ExceptionData | null;
    /**
     * 
     * @type {Exception}
     * @memberof Ptw100BadRequestException
     */
    innerException?: Exception;
    /**
     * 
     * @type {string}
     * @memberof Ptw100BadRequestException
     */
    helpLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100BadRequestException
     */
    source?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100BadRequestException
     */
    hResult?: number;
    /**
     * 
     * @type {string}
     * @memberof Ptw100BadRequestException
     */
    readonly stackTrace?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100BadRequestException
     */
    code?: number;
    /**
     * 
     * @type {I18nInfo}
     * @memberof Ptw100BadRequestException
     */
    i18n?: I18nInfo;
    /**
     * 
     * @type {Array<PtwValidationResult>}
     * @memberof Ptw100BadRequestException
     */
    validationErrors?: Array<PtwValidationResult> | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100BadRequestException
     */
    $type?: Ptw100BadRequestExceptionTypeEnum;
}


/**
 * @export
 */
export const Ptw100BadRequestExceptionTypeEnum = {
    PtwPtw100AppZeroCoreSharedExceptionsPtw100BadRequestExceptionPtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100BadRequestException, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type Ptw100BadRequestExceptionTypeEnum = typeof Ptw100BadRequestExceptionTypeEnum[keyof typeof Ptw100BadRequestExceptionTypeEnum];



/**
 * Check if a given object implements the Ptw100BadRequestException interface.
 */
export function instanceOfPtw100BadRequestException(value?: unknown): value is Ptw100BadRequestException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(Ptw100BadRequestExceptionTypeEnum)[0];
}

export function Ptw100BadRequestExceptionFromJSON(json: any): Ptw100BadRequestException {
    return Ptw100BadRequestExceptionFromJSONTyped(json, false);
}

export function Ptw100BadRequestExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ptw100BadRequestException {
    if (json == null) {
        return json;
    }
    return {
        
        'targetSite': json['targetSite'] == null ? undefined : json['targetSite'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ExceptionDataFromJSON(json['data']),
        'innerException': json['innerException'] == null ? undefined : ExceptionFromJSON(json['innerException']),
        'helpLink': json['helpLink'] == null ? undefined : json['helpLink'],
        'source': json['source'] == null ? undefined : json['source'],
        'hResult': json['hResult'] == null ? undefined : json['hResult'],
        'stackTrace': json['stackTrace'] == null ? undefined : json['stackTrace'],
        'code': json['code'] == null ? undefined : json['code'],
        'i18n': json['i18n'] == null ? undefined : I18nInfoFromJSON(json['i18n']),
        'validationErrors': json['validationErrors'] == null ? undefined : ((json['validationErrors'] as Array<any>).map(PtwValidationResultFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function Ptw100BadRequestExceptionToJSON(value?: Omit<Ptw100BadRequestException, 'targetSite'|'message'|'stackTrace'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'data': ExceptionDataToJSON(value['data']),
        'innerException': ExceptionToJSON(value['innerException']),
        'helpLink': value['helpLink'],
        'source': value['source'],
        'hResult': value['hResult'],
        'code': value['code'],
        'i18n': I18nInfoToJSON(value['i18n']),
        'validationErrors': value['validationErrors'] == null ? undefined : ((value['validationErrors'] as Array<any>).map(PtwValidationResultToJSON)),
        '$type': value['$type'],
    });
}

